<template>
  <div>
    <sweet-input
      :isValid="!$v.form.name.$error"
      @input="$v.form.name.$touch()"
      v-model="form.name"
      type="text"
      layout="vertical"
      :placeholder="$t('common.name')"
      :label="$t('common.person-name-surname')"
      class="mt-2"
    />
    <sweet-input
      :isValid="!$v.form.email.$error"
      @input="$v.form.email.$touch()"
      v-model="form.email"
      type="email"
      layout="vertical"
      :placeholder="$t('common.email')"
      label="Email"
      labelClass="mt-2"
    />
    <h6 class="mt-2">{{ $t("common.language") }}</h6>
    <multiselect
      v-model="form.language"
      track-by="language"
      :placeholder="$t('common.language-select')"
      :options="languages"
      :searchable="false"
      :allow-empty="false"
      :show-labels="false"
      @select="onSelect"
      class="mt-1"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
        <span class="align-middle">{{ option.title[option.language] }}</span>
      </template>
      <template slot="option" slot-scope="{ option }">
        <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
        <span class="align-middle">{{ option.title[option.language] }}</span>
      </template>
    </multiselect>
    <br />

    <filter-select
      v-if="!disableRoles"
      id="roleFilter"
      ref="roleFilter"
      :placeholder="$t('Organizasyon Rol Seçiniz')"
      :multiple="true"
      @filter="onRoleSearch"
      :selected="form.organizationRole"
      @changed="roleSelect"
      track="_id"
    />

    <sweet-button @click="invite()" class="mt-4" :disabled="$v.form.$invalid" buttonClass="mt-3" variant="success" icon="mdi mdi-account-check" size="sm">
      <span v-if="inviteButtonText">{{ inviteButtonText }}</span>
      <span v-else> {{ $t("organization.allow-access-to-organization") }}</span>
    </sweet-button>
  </div>
</template>

<script>
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: { organization: { type: Object }, store: { type: String, required: false }, disableRoles: { type: Boolean, default: false }, inviteButtonText: { type: String } },
  data() {
    return {
      form: {
        name: undefined,
        email: undefined,
        language: undefined,
        organizationRole: undefined,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(40),
      },

      email: {
        email,
        required,
      },
    },
  },
  computed: {
    languages() {
      return this.$store.getters["localization/languages"];
    },
    roles() {
      return this.$store.getters[`role/pagination`];
    },
    currentStore() {
      return this.store ? this.store : "organization";
    },
    accessableRoles() {
      return this.$store.getters["user/accessableRoles"] || [];
    },
  },
  mounted() {
    this.form.language = this.languages.find((l) => l.language == "tr");
  },
  methods: {
    async invite() {
      try {
        await this.$store.dispatch(`${this.currentStore}/invite`, {
          ...this.form,
          language: this.form.language.language,
          organization: this.organization,
        });
        this.$toast.success(this.$t("common.success"));
        this.$emit("closeModal");

        setTimeout(() => {
          this.$emit("closeForm");
        }, 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    onSelect() {
      this.$forceUpdate();
    },

    roleSelect(item) {
      this.form = { ...this.form, organizationRole: item };
    },
    async onRoleSearch(value, callback) {
      const ac = this.accessableRoles.map((i) => i._id);

      const response = await this.$store.dispatch(`role/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, _id: { value: { $in: ac }, isObject: true } },
      });

      callback(response.data?.docs ?? []);
    },
  },
};
</script>
<style>
.multiselect__content-wrapper {
  position: relative;
}
</style>
